export default "__VITE_ASSET__CAzQT6r9__"